import * as sentryBrowser from '@sentry/browser';
import { useContext } from 'react';
import SentrySdk from '../contexts/sentry-sdk.js';
export default function useSentrySdk() {
    return useContext(SentrySdk) ?? sentryBrowser;
}
//# sourceMappingURL=use-sentry-sdk.js.map